import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Course } from 'src/app/shared/models/training/course.model';
import { ExchangeApiService } from '../exchange-api.service';

export interface CoursesResult {
  'hydra:member': Course[];
  'hydra:totalItems': number;
}

@Injectable()
export class CourseService {

  path = 'courses';

  constructor(
    private apiService: ExchangeApiService,
  ) {
  }

  public get(id: string): Observable<Course> {
    return this.apiService.getSave(`${this.path}/${id}`)
      .pipe(map(data => new Course(data)));
  }

  public  getAll(params: HttpParams = new HttpParams()): Observable<CoursesResult> {
    return this.apiService.getSave(this.path, [params])
      .pipe(
        map(data => {
          data['hydra:member'] = data['hydra:member'].map(course => new Course(course));
          return data;
        }),
      );
  }
}
